import {
  DrawerMenuItemLinkType,
  Icon,
  IconCounter,
  useColorScheme,
  useHover,
  useLocales,
} from "@/lib/main";
import { CSSProperties } from "react";
import { NavLink, useLocation } from "react-router";

type Props = {
  drawerMenuItem: DrawerMenuItemLinkType;
  isHashLinks?: boolean;
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
  shoppingCartCount?: number;
};

export default function DrawerMenuItemLink({
  drawerMenuItem,
  isHashLinks,
  setIsDrawerOpen,
  shoppingCartCount,
}: Props) {
  const location = useLocation();
  const l = useLocales();
  const { colorScheme } = useColorScheme();
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();

  const currentLocation = isHashLinks
    ? location.pathname + location.hash
    : location.pathname;
  const isActive = drawerMenuItem.to === currentLocation;

  const handleClick = () => setIsDrawerOpen(false);

  const liStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",

    width: "100%",

    borderBottom: "var(--border-width-xs) solid var(--color-border-subtle)",
    backgroundColor: isHovered
      ? colorScheme === "dark"
        ? "var(--color-background-frame)"
        : "var(--color-background-canvas)"
      : "transparent",
  };

  const linkStyle: CSSProperties = {
    display: "flex",
    gap: "var(--spacing-sm)",
    alignItems: "center",

    width: "100%",
    padding: "var(--spacing-md) var(--page-padding-horizontal)",

    fontSize: "var(--font-size-drawer-item)",
  };

  return (
    <li
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={liStyle}
    >
      <NavLink
        className={() => {
          return isActive ? "font-color-nav active" : "font-color-nav";
        }}
        style={linkStyle}
        to={drawerMenuItem.to}
      >
        {drawerMenuItem.cartCount && shoppingCartCount ? (
          <IconCounter
            count={shoppingCartCount}
            iconColor={isActive ? "active" : "secondary"}
            iconName="shopping-cart"
          />
        ) : (
          <Icon
            color={isActive ? "active" : "secondary"}
            name={drawerMenuItem.icon}
            size="md"
          />
        )}

        {l(drawerMenuItem.title)}
      </NavLink>
    </li>
  );
}
